import ExpenseFormModal from './ExpenseFormModal';
import { useExpenseCategories } from './useFinance';

interface QuickExpenseProps {
  toggle: () => void;
}

/**
 * "Registrar gasto" from anywhere. Waits for the categories before opening:
 * the form picks the first active one as its default when it opens.
 */
export default function QuickExpense({ toggle }: QuickExpenseProps) {
  const categories = useExpenseCategories({ limit: 100 });

  if (!categories.data) return null;

  return <ExpenseFormModal isOpen toggle={toggle} categories={categories.data.items} />;
}
